var _path, _g, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1000,
    height: 803,
    viewBox: "0 0 1000 803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 448 360",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 803,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 448 360",
    height: 360,
    width: 448,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 448 360",
    height: 360,
    width: 448,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M193.855 44.683c1.378 0 2.494 1.116 2.495 2.494 0 1.378-1.116 2.494-2.495 2.495h-23.846l-17.167 17.167c-0.973 0.973-2.551 0.973-3.53 0-0.973-0.973-0.973-2.551 0-3.529l13.644-13.645h-40.378c-11.518 0-19.151 2.688-23.815 8.113-4.739 5.519-6.66 14.056-6.66 25.63 0 0.069 0 0.137-0.006 0.206l0.212 36.692 14.692-14.692c0.973-0.973 2.551-0.973 3.53 0 0.973 0.973 0.973 2.551 0 3.53l-18.178 18.178c0.206 35.832 0.193 71.358-0.013 107.19 25.486 25.2 50.617 50.312 75.811 75.791h25.38c1.378 0 2.494 1.116 2.495 2.495 0 1.378-1.116 2.494-2.495 2.494h-20.448l25.942 26.241 0.006-0.006c8.188 8.188 15.577 12.859 22.824 13.413 7.146 0.543 14.442-2.956 22.586-11.093l28.555-28.555h-20.722c-1.378 0-2.494-1.116-2.495-2.494 0-1.378 1.116-2.494 2.495-2.495h25.711l16.625-16.625c0.973-0.973 2.551-0.973 3.529 0 0.973 0.973 0.973 2.551 0 3.53l-13.101 13.102h40.377c11.518 0 19.151-2.688 23.815-8.113 4.739-5.519 6.66-14.056 6.66-25.63h0.013l-0.212-36.898-16.014 16.014c-0.973 0.973-2.551 0.973-3.53 0-0.973-0.973-0.973-2.551 0-3.53l19.5-19.5c-0.206-35.832-0.193-71.358 0.013-107.19-25.486-25.2-50.617-50.312-75.811-75.791h-26.147c-1.378 0-2.494-1.116-2.495-2.495 0-1.378 1.116-2.494 2.495-2.494h21.215l-25.824-26.123c-0.044-0.037-0.081-0.075-0.124-0.112-8.188-8.188-15.577-12.859-22.824-13.413-7.146-0.543-14.442 2.956-22.586 11.093l-28.555 28.555h18.858zM122.578 44.683h45.367l32.078-32.078c9.248-9.248 17.81-13.195 26.484-12.534 8.568 0.649 16.956 5.824 25.985 14.854 0.05 0.05 0.094 0.094 0.137 0.143l29.278 29.615h43.508c13.071 0 21.919 3.268 27.594 9.871 5.6 6.517 7.864 16.101 7.864 28.867 0 0.081-0.006 0.156-0.012 0.23l-0.225 39.742 28.43 28.112 0.006-0.006c9.03 9.03 14.206 17.411 14.854 25.985 0.661 8.674-3.293 17.236-12.534 26.484l-30.768 30.768 0.237 41.843h0.012c0 12.765-2.27 22.35-7.864 28.867-5.675 6.604-14.524 9.872-27.594 9.871h-45.366l-32.078 32.078c-9.248 9.248-17.81 13.195-26.484 12.534-8.568-0.649-16.956-5.824-25.985-14.854l0.006-0.006-29.421-29.758h-43.509c-13.071 0-21.919-3.268-27.594-9.872-5.6-6.517-7.864-16.101-7.863-28.866h0.012l0.231-39.972-28.293-27.969c-0.05-0.044-0.1-0.087-0.143-0.137-9.03-9.03-14.206-17.411-14.854-25.985-0.661-8.674 3.293-17.236 12.534-26.484l30.768-30.768-0.237-41.607c-0.006-0.075-0.012-0.156-0.012-0.23 0-12.765 2.27-22.35 7.864-28.867 5.675-6.604 14.524-9.872 27.594-9.871zM87.682 179.997l-0.274-47.724-27.276 27.276c-8.138 8.138-11.636 15.44-11.094 22.587 0.549 7.246 5.226 14.642 13.413 22.823 0.037 0.037 0.081 0.081 0.113 0.125l24.837 24.551 0.281-49.644zM92.303 241.483l-0.2 35.09h0.013c0 11.58 1.921 20.117 6.66 25.63 4.664 5.432 12.297 8.113 23.815 8.113h38.576l-33.55-33.936-35.308-34.903zM325.415 49.672h-38.575l33.549 33.936 35.308 34.902 0.2-34.884c-0.006-0.069-0.006-0.137-0.007-0.205 0-11.58-1.921-20.117-6.66-25.63-4.664-5.432-12.297-8.113-23.815-8.113zM360.599 130.352l-0.281 49.645 0.274 47.724 27.276-27.276c8.138-8.138 11.636-15.44 11.094-22.587-0.549-7.252-5.226-14.642-13.413-22.824l0.006-0.006-24.956-24.669z",
    fill: "#dedede",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    },
    "data-fill-palette-color": "tertiary"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,140.75,90)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 166.5 180",
    height: 180,
    width: 166.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 166.5 180",
    height: 180,
    width: 166.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 166.5 180",
    height: 180,
    width: 166.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 166.5 180",
    height: 180,
    width: 166.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 166.5 180",
    height: 180,
    width: 166.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 166.5 180",
    height: 180,
    width: 166.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 166.5,
    viewBox: "1.5 -25.450000762939453 24.049999237060547 26",
    height: 180,
    "data-palette-color": "#dedede",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7-25.45L12.7-25.45Q16.7-25.45 18.88-23.43 21.05-21.4 21.05-17.35L21.05-17.35 21.05-6.4Q21.05-4.95 21.5-4.45 21.95-3.95 22.65-3.95L22.65-3.95Q23.15-3.95 23.63-4.05 24.1-4.15 24.6-4.35L24.6-4.35 25.55-0.95Q24.45-0.35 23.05 0.03 21.65 0.4 20.5 0.4L20.5 0.4Q18.7 0.4 17.6-0.35 16.5-1.1 16.05-2.95L16.05-2.95Q14.65-1 12.78-0.23 10.9 0.55 8.55 0.55L8.55 0.55Q5.65 0.55 3.58-1.13 1.5-2.8 1.5-5.85L1.5-5.85Q1.5-8.55 2.78-10.28 4.05-12 6.1-12.93 8.15-13.85 10.53-14.2 12.9-14.55 15.05-14.55L15.05-14.55 15.05-17.8Q15.05-19.8 14.2-20.55 13.35-21.3 11.45-21.3L11.45-21.3Q9.75-21.3 8.05-20.35 6.35-19.4 5.05-18.4L5.05-18.4 2.6-22.35Q4.85-23.9 7.43-24.68 10-25.45 12.7-25.45ZM15.05-9.3L15.05-10.45Q14-10.45 12.75-10.35 11.5-10.25 10.35-9.85 9.2-9.45 8.47-8.65 7.75-7.85 7.75-6.45L7.75-6.45Q7.75-5.3 8.68-4.67 9.6-4.05 10.65-4.05L10.65-4.05Q12.05-4.05 13.03-4.85 14-5.65 14.53-6.88 15.05-8.1 15.05-9.3L15.05-9.3Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#dedede",
    className: "undefined-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))), _g || (_g = /*#__PURE__*/React.createElement("g", null)))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 448,
    height: 360,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b8a085cbfeca919d2e68a71e400bebdb.svg";
export { ForwardRef as ReactComponent };